import { useEffect, useState } from "react";

import { apiClient } from "../api/client.js";

export function VenueGameSettings({ slug, canEdit }: { slug: string; canEdit: boolean }) {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [editingEnabled, setEditingEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    let cancelled = false;
    setEnabled(null);
    apiClient["/api/v1/admin/venues/{slug}/game-settings"]
      .get({ parameters: { slug }, body: null })
      .then((res) => {
        if (cancelled) return;
        if (res.code === 200) {
          setEnabled(res.body.sound_override !== "muted");
          setEditingEnabled(res.body.editing_enabled);
        } else setMessage("Could not load game settings.");
      })
      .catch(() => {
        if (!cancelled) setMessage("Could not load game settings.");
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);
  async function save(value: boolean) {
    setBusy(true);
    setMessage("");
    try {
      const res = await apiClient["/api/v1/admin/venues/{slug}/game-settings"].put({
        parameters: { slug },
        body: { sound_override: value ? "enabled" : "muted" },
      });
      if (res.code === 200) {
        setEnabled(res.body.sound_override !== "muted");
        setMessage("Saved. Connected tables receive settings on their next heartbeat.");
      } else setMessage(res.body?.message ?? "Could not save game settings.");
    } catch {
      setMessage("Could not save game settings.");
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="bg-surface-raised border border-border rounded-lg p-6 mb-6">
      <h2 className="text-lg font-semibold mb-4">Game Settings</h2>
      <label className="flex gap-3 items-center">
        <input
          type="checkbox"
          checked={enabled ?? true}
          disabled={!canEdit || !editingEnabled || busy || enabled === null}
          onChange={(e) => void save(e.target.checked)}
        />
        Enable Sound
      </label>
      {!editingEnabled && (
        <p className="text-sm text-text-muted mt-2">
          Sound editing becomes available after the games update.
        </p>
      )}
      {message && (
        <p role="status" className="text-sm mt-2">
          {message}
        </p>
      )}
    </section>
  );
}
